export default __webpack_public_path__ + "static/media/ios-s2_bk.e91757b2.webp";